/**
 * @function limitTextLength 字段的最小字数和最大字数
 * @param minMaxArr 最小值最大值的数组
 */
const limitTextLength = (minMaxArr) => {
  return ["limitTextLength", minMaxArr];
};

/**
 * @function customValidator 自定义验证
 * @param args 自定义参数
 */
const customValidator = (type, trigger = "change", ...args) => {
  return ["customValidator", trigger, type, ...args];
};

/**
 * @function houseRules 自定义验证
 * @param args 自定义参数
 */
const houseRules = (type, trigger = "change", ...args) => {
  return ["houseRules", trigger, type, ...args];
};

/**
 * @function trafficRules 自定义验证
 * @param args 自定义参数
 */
const trafficRules = (type, trigger = "change", ...args) => {
  return ["trafficRules", trigger, type, ...args];
};

/**
 * @function patternCustom 自定义验证
 * @param pattern 正则表达
 * @param message 错误提示
 */
const patternCustom = (pattern, message) => {
  return ["patternCustom", pattern, message];
};

/**
 * @function totalValidWithNumber 要求多个字段和为指定值
 * @param total 总和
 * @param keys 加数字段数组
 * @param message 错误提示信息
 */
const totalValidWithNumber = (total, keys, message) => {
  return ["totalValidWithNumber", total, keys, message];
};

/**
 * @function totalValidWithKey 要求多个字段和为指定值
 * @param key 总数对应字段
 * @param keys 加数字段数组
 * @param message 错误提示信息
 */
const totalValidWithKey = (key, keys, message) => {
  return ["totalValidWithKey", key, keys, message];
};

/**
 * @function numberValidWithDecimal 数字保留小数位
 * @param decLength 要求保留小数位
 * @param spValues 特殊值填写
 */
const numberValidWithDecimal = (decLength, spValues, excludeZero) => {
  return ["numberValidWithDecimal", decLength, spValues, excludeZero];
};

/**
 * @function numberValidWithMaxDecimal 数字保留小数位
 * @param decLength 要求保留小数位
 */
const numberValidWithMaxDecimal = (decLength, spValues, excludeZero) => {
  return ["numberValidWithMaxDecimal", decLength, spValues, excludeZero];
};

/**
 * @function validNumberRange 数字填写范围
 * @param range 数字范围如[1, 10]
 * @param message 提示信息
 */
const validNumberRange = (range, message) => {
  return ["validNumberRange", range, message];
};

/**
 * @function patternValid 要求字段满足某种格式
 * @param pattern 正则验证模板类型，可选如下：
 * 手机: phone
 * 电话: cell
 * 手机或电话: cellOrPhone
 * 网址: url
 * 邮箱: email
 * 邮编: post
 * 军官证: officialCard
 * 护照: passport
 * 台湾同胞通行证: twPassport
 */
const patternValid = (pattern) => {
  return ["patternValid", pattern];
};

/**
 * @function idCardNoValid 身份证号码验证
 */
const idCardNoValid = () => {
  return ["idCardNoValid"];
};

/**
 * @function orgCode 组织机构代码
 */
const orgCode = () => {
  return ["orgCode"];
};

/**
 * @function societyCode 社会信用代码
 */
const societyCode = () => {
  return ["societyCode"];
};

/**
 * @function orgOrSociety 组织机构代码或社会信用代码
 */
const orgOrSociety = (isStrict) => {
  return ["orgOrSociety", isStrict];
};

const patternType = {
  phone: "phone",
  fax: "fax",
  cell: "cell",
  cellOrPhone: "cellOrPhone",
  mulPhone: "mulPhone",
  url: "url",
  email: "email",
  post: "post",
  officialCard: "officialCard",
  passport: "passport",
  twPassport: "twPassport",
};

const rules = {
  totalValidWithKey,
  totalValidWithNumber,
  numberValidWithDecimal,
  numberValidWithMaxDecimal,
  validNumberRange,
  patternValid,
  idCardNoValid,
  orgCode,
  societyCode,
  orgOrSociety,
  limitTextLength,
  customValidator,
  houseRules,
  trafficRules,
  patternCustom,
};

module.exports = {
  patternType,
  rules,
};
